import { render, staticRenderFns } from "./OfferEdit.vue?vue&type=template&id=5a1193aa&scoped=true"
import script from "./OfferEdit.vue?vue&type=script&lang=js"
export * from "./OfferEdit.vue?vue&type=script&lang=js"
import style0 from "./OfferEdit.vue?vue&type=style&index=0&id=5a1193aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a1193aa",
  null
  
)

export default component.exports